import Icon from 'scripts/components/basic/Icon.vue';
import Modal from 'scripts/components/basic/Modal.vue';
import Accordion from 'scripts/components/basic/Accordion.vue';
import AccordionGroup from 'scripts/components/basic/AccordionGroup.vue';
import VLink from 'scripts/components/buttons/VLink.vue';
import VButton from 'scripts/components/buttons/VButton.vue';
import TextInput from 'scripts/components/forms/TextInput.vue';
import CheckboxInput from 'scripts/components/forms/CheckboxInput.vue';
import QuantityInput from 'scripts/components/forms/QuantityInput.vue';
import RadioInput from 'scripts/components/forms/RadioInput.vue';
import SelectInput from 'scripts/components/forms/SelectInput.vue';
import KlaviyoForm from 'scripts/components/forms/KlaviyoForm.vue';
import Account from 'scripts/components/account/Account.vue';
import Signup from 'scripts/components/account/Signup.vue';
import Signin from 'scripts/components/account/Signin.vue';
import Forgot from 'scripts/components/account/Forgot.vue';
import Profile from 'scripts/components/account/Profile.vue';
import ProductTile from 'scripts/components/product/ProductTile.vue';
import ProductDisplay from 'scripts/components/product/ProductDisplay.vue';
import ProductGallery from 'scripts/components/product/ProductGallery.vue';
import ProductInfo from 'scripts/components/product/ProductInfo.vue';
import ProductForm from 'scripts/components/product/ProductForm.vue';
import ProductBuyInStore from 'scripts/components/product/ProductBuyInStore.vue';
import TabsSelect from 'scripts/components/basic/TabsSelect.vue';
import Tabs from 'scripts/components/basic/Tabs.vue';
import Tab from 'scripts/components/basic/Tab.vue';
import NutritionFacts from 'scripts/components/product/NutritionFacts.vue';
import ScrollToTop from 'scripts/components/basic/ScrollToTop.vue';

import { swiper, swiperSlide } from 'vue-awesome-swiper';
import Sidecart from 'scripts/components/cart/Sidecart.vue';
import CartLineItem from 'scripts/components/cart/CartLineItem.vue';
import CollectionTiles from 'scripts/components/sections/CollectionTiles.vue';
import ProductReviews from 'scripts/components/sections/ProductReviews.vue';

export default {
  Icon,
  Modal,
  Accordion,
  AccordionGroup,
  VLink,
  VButton,
  TextInput,
  CheckboxInput,
  QuantityInput,
  RadioInput,
  SelectInput,
  Sidecart,
  KlaviyoForm,
  Account,
  Signup,
  Signin,
  Forgot,
  Profile,
  ProductTile,
  ProductDisplay,
  ProductGallery,
  ProductInfo,
  ProductForm,
  ProductBuyInStore,
  TabsSelect,
  Tabs,
  Tab,
  NutritionFacts,
  ScrollToTop,
  swiperSlide,
  CartLineItem,
  CollectionTiles,
  ProductReviews
};
